<template>
  <div class="text-xs-right grey--text body-2">
    <v-chip
      small
      v-if="!!contractorId"
      @click="drawer = true"
      :color="$store.state.global.pages.contractor.color"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>{{$store.state.global.pages.contractor.icon}}</v-icon>
      </v-avatar>
      {{contractorName}}
    </v-chip>

    <v-chip
      small
      v-if="!!vehicleId"
      @click="drawer = true"
      :color="$store.state.global.pages.vehicle.color"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>{{$store.state.global.pages.vehicle.icon}}</v-icon>
      </v-avatar>
      {{vehicleName}}
    </v-chip>

    <v-chip
      small
      v-if="!!driverId"
      @click="drawer = true"
      :color="$store.state.global.pages.driver.color"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>{{$store.state.global.pages.driver.icon}}</v-icon>
      </v-avatar>
      {{driverName}}
    </v-chip>

    <v-chip
      small
      v-if="!!resourceType"
      @click="drawer = true"
      :color="$store.state.global.pages.compliance.color"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>{{$store.state.global.pages.compliance.icon}}</v-icon>
      </v-avatar>
      {{!!resourceTypeObj ? resourceTypeObj.text : ''}}
    </v-chip>

    <v-chip
      small
      v-if="(!!dateRangeStart || !!dateRangeEnd) && !useSingleDate"
      @click="drawer = true"
      color="red"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>date_range</v-icon>
      </v-avatar>
      {{!!dateRangeStart ? makeShortDate(dateRangeStart) : ''}} - {{!!dateRangeEnd ? makeShortDate(dateRangeEnd) : ''}}
    </v-chip>
    <v-chip
      small
      v-if="(!!dateRangeStart || !!dateRangeEnd) && useSingleDate"
      @click="drawer = true"
      color="red"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>date_range</v-icon>
      </v-avatar>
      {{!!dateRangeStart ? makeShortDate(dateRangeStart) : ''}}
    </v-chip>

    <!-- <v-chip
      small
      v-if="(!!dateRangeStart || !!dateRangeEnd)"
      @click="drawer = true"
      color="red"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>date_range</v-icon>
      </v-avatar>
      {{!!dateRangeStart ? makeShortDate(dateRangeStart) : ''}} - {{!!dateRangeEnd ? makeShortDate(dateRangeEnd) : ''}}
    </v-chip>-->
  </div>
</template>

<script>
import Store from '@/store/computed/storeHelpers'

// MIXINS
import GetNamesFromIds from '@/services/mixins/getNamesFromIds'
import FormatDates from '@/services/mixins/formatDates'

export default {
  mixins: [GetNamesFromIds, FormatDates],
  computed: {
    drawer: Store.getSet({ store: 'compliance', prop: 'drawer' }),
    contractorId: Store.getSet({ store: 'compliance', prop: 'contractorId' }),
    vehicleId: Store.getSet({ store: 'compliance', prop: 'vehicleId' }),
    driverId: Store.getSet({ store: 'compliance', prop: 'driverId' }),
    dateRangeStart: Store.getSet({
      store: 'compliance',
      prop: 'dateRangeStart'
    }),
    dateRangeEnd: Store.getSet({ store: 'compliance', prop: 'dateRangeEnd' }),
    resourceType: Store.getSet({ store: 'compliance', prop: 'resourceType' }),
    contractors: Store.getSet({ store: 'contractors', prop: 'contractors' }),
    vehicles: Store.getSet({ store: 'vehicles', prop: 'vehicles' }),
    drivers: Store.getSet({ store: 'drivers', prop: 'drivers' }),
    resourceTypeObj: Store.getSet({
      store: 'compliance',
      prop: 'resourceTypeObj'
    }),
    useSingleDate: Store.getSet({ store: 'shared', prop: 'useSingleDate' })
  }
}
</script>

<style>
.v-chip .v-chip__content {
  cursor: pointer;
}
</style>